import "../ContractCoverageIntelligence.scss";
import "./ContractCoverageZebra.scss";
import React from "react";
import {observer} from "mobx-react-lite";
import {Box, Button, Typography} from "@mui/material";
import {FileDownloadOutlined} from "@mui/icons-material";
import {useGridApiRef} from "@mui/x-data-grid-premium";
import {MainPageFacade} from "~/components/main/page/MainPageFacade.tsx";
import {CARD_CONFIG} from "~/components/dashboard/DashboardCardConfigs.tsx";
import {ZebraCoverageTable} from "./ZebraCoverageTable.tsx";
import {CoverageKpis} from "~/experiments/pages/contract-coverage-intelligence/components/CoverageKpis.tsx";
import {COVERAGE_KPIS, COVERAGE_SUBTITLE} from "../contractCoverageData";
import type {CoverageFilterKey} from "../contractCoverageUtils";
import {formatNumber} from "../contractCoverageUtils";
import {exportContractCoverageCsv} from "../contractCoverageExport";
import {useContractParentsQuery} from "../useContractParentsQuery";

export const ContractCoverageZebraPage: React.FC = observer(() => {
    const apiRef = useGridApiRef();
    const {data: rows = [], isPending} = useContractParentsQuery();
    const k = COVERAGE_KPIS;

    const [activeFilter, setActiveFilter] = React.useState<CoverageFilterKey | null>(null);
    const toggleFilter = React.useCallback(
        (key: CoverageFilterKey) => setActiveFilter(cur => (cur === key ? null : key)), []);

    const exportButton = (
        <Button
            variant="outlined"
            size="small"
            startIcon={<FileDownloadOutlined/>}
            onClick={() => exportContractCoverageCsv(rows)}>
            Export
        </Button>
    );

    return <MainPageFacade
        title={CARD_CONFIG['contract-coverage-intelligence'].title}
        className="cci-page ccz-page"
        actionBarEnd={exportButton}>

        <Typography className="cci-subtitle" variant="body2">
            {COVERAGE_SUBTITLE}
        </Typography>

        <CoverageKpis kpis={k} activeFilter={activeFilter} onToggleFilter={toggleFilter}/>

        <Box className="cci-table-card">
            <Box className="cci-table-card-header">
                <Typography variant="h2" sx={{fontSize: 18, fontWeight: 700}}>
                    Contract coverage by parent supplier ({formatNumber(rows.length)})
                </Typography>
                <span className="cci-table-card-hint">
                    Top {formatNumber(rows.length)} parents by spend · click a row to expand · linked parents open their contract overview
                </span>
            </Box>
            <ZebraCoverageTable rows={rows} apiRef={apiRef} activeFilter={activeFilter}
                                loading={isPending}
                                onClearFilter={() => setActiveFilter(null)}/>
        </Box>
    </MainPageFacade>;
});
